export default {
  setAllVariations ({ state, commit }, data) {
    commit('setAllVariations', data)
  },
  setRelatedVariationData ({ commit }, payload) {
    commit('setRelatedVariationData', payload)
  },
  setVariationsActive ({ commit }, payload) {
    commit('setVariationsActive', payload)
  },
  setListingVariationGroupCombos ({ commit }, payload) {
    commit('setListingVariationGroupCombos', payload)
  },
  setVariationFilterQueryStringVar ({ commit }, payload) {
    commit('setVariationFilterQueryStringVar', payload)
  },
  setActiveVariationFilters ({ commit }, payload) {
    commit('setActiveVariationFilters', payload)
  },
  setVariationRecordsUsed ({ commit }, payload) {
    commit('setVariationRecordsUsed', payload)
  },
  setProductVariationInfoData ({ commit }, payload) {
    commit('setProductVariationInfoData', payload)
  },
  setVariationMergeDuplicateValuesByName ({ commit }, payload) {
    commit('setVariationMergeDuplicateValuesByName', payload)
  }
}
